export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line', count: '120+' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line', count: '85+' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line', count: '200+' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-t-shirt-air-line', count: '65+' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line', count: '90+' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-copyleft-line', count: '45+' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line', count: '55+' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-line', count: '70+' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-shirt-fill', count: '40+' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line', count: '110+' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-handbag-line', count: '80+' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link', count: '35+' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line', count: '50+' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line', count: '150+' },
];

export const trendingItems = [
  {
    name: 'Nike Dunk Low Panda',
    price: 'From $28',
    tag: 'New',
    seq: 'trending-01',
    query: 'Nike%20Dunk%20Low%20Panda%20sneakers%20on%20white%20background%20minimalist%20product%20photography%20soft%20natural%20lighting%20clean%20studio%20shot%20fashion%20editorial%20style%20with%20warm%20neutral%20tones%20and%20gentle%20shadows',
  },
  {
    name: 'Essentials Hoodie Grey',
    price: 'From $32',
    seq: 'trending-02',
    query: 'Grey%20Essentials%20hoodie%20streetwear%20on%20clean%20white%20background%20minimal%20product%20photography%20soft%20studio%20lighting%20modern%20fashion%20editorial%20warm%20neutral%20aesthetic%20simple%20composition',
  },
  {
    name: 'Yeezy Slide Bone',
    price: 'From $18',
    seq: 'trending-03',
    query: 'Bone%20colored%20Yeezy%20slides%20sandals%20on%20minimal%20cream%20background%20clean%20product%20photography%20soft%20natural%20light%20studio%20shot%20modern%20fashion%20editorial%20warm%20neutral%20tones',
  },
  {
    name: 'Designer Tote Bag',
    price: 'From $45',
    seq: 'trending-04',
    query: 'Elegant%20designer%20tote%20bag%20on%20clean%20white%20background%20minimalist%20product%20photography%20soft%20studio%20lighting%20modern%20fashion%20editorial%20warm%20neutral%20aesthetic%20with%20gentle%20shadows',
  },
];

export const faqItems = [
  {
    question: 'What is a PandabuySpreadsheet?',
    answer: 'A PandabuySpreadsheet is a curated product indexing system that organizes thousands of items into structured spreadsheets, allowing users to discover fashion products faster, compare prices across categories, and access agent-based shopping platforms efficiently. Each spreadsheet entry includes product links, price ranges, quality ratings, and category tags to streamline your shopping experience.',
  },
  {
    question: 'How often is the PandabuySpreadsheet updated?',
    answer: 'Our PandabuySpreadsheet database is updated daily with new finds, trending items, and verified product listings. We continuously monitor popular categories like shoes, streetwear, and accessories to ensure you always have access to the freshest curated content available on agent shopping platforms.',
  },
  {
    question: 'Do I need an account to use PandabuySpreadsheet?',
    answer: 'No signup or registration is required. All PandabuySpreadsheet collections are freely accessible — simply browse categories, click through to product listings, and start discovering curated fashion finds immediately. We believe in making spreadsheet shopping as frictionless as possible.',
  },
  {
    question: 'How do I use a Pandabuy Spreadsheet for shopping?',
    answer: 'Using a Pandabuy Spreadsheet is straightforward: browse our category pages to find the type of product you are looking for, click any listing to open the product page on the agent platform, copy the product link into your preferred shopping agent, and complete your purchase. Each spreadsheet entry is organized with clear categories, making navigation intuitive even for beginners.',
  },
  {
    question: 'Are the products in PandabuySpreadsheet verified?',
    answer: 'Yes, our team carefully curates and verifies each PandabuySpreadsheet listing. We prioritize listings with positive feedback, clear product images, and reliable seller histories. While we strive to maintain high-quality curated lists, we always recommend reviewing individual product pages before purchasing.',
  },
];

export const testimonials = [
  {
    quote: 'I have been using PandabuySpreadsheet for over six months now, and it completely transformed how I shop for streetwear. The curated lists save me hours of searching, and I have discovered so many incredible finds I would have never come across otherwise. The structured spreadsheet format makes comparing items across categories effortless.',
    author: 'Fashion Insider',
    role: 'Verified Shopper',
  },
  {
    quote: 'As someone new to agent shopping, PandabuySpreadsheet was a total game-changer. The beginner-friendly layout and clear category system helped me navigate the entire process without any confusion. Within my first week, I had already placed three orders using their curated shoe and accessories spreadsheets.',
    author: 'Style Curator',
    role: 'Verified Shopper',
  },
  {
    quote: 'The daily updates on PandabuySpreadsheet are honestly unmatched. Every morning I check the new drops, and I am always impressed by the quality of the curated selections. The hoodies and jackets categories in particular have some of the best spreadsheet finds I have seen anywhere online.',
    author: 'Trend Analyst',
    role: 'Verified Shopper',
  },
];